import Vue from "vue";
import Vuex from "vuex";
import { User } from "firebase";
import {
  JinroPlayerDocument,
  JinroGamePlayinfoDocument,
  jinroPlayerGameDocument,
  JinroGameDocument,
  JinroRoomDocument,
  UserDocument,
  GmJinroGameDocument,
} from "@/services/datatypes";
import { SoundSettingvalues } from "@/services/settings";
import { DEFAULT_SOUND_VOLUME } from "@/services/constants";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    firebaseUser: undefined as User | null | undefined,
    user: undefined as UserDocument | null | undefined,
    jinroRoomPlayers: undefined as
      | Array<JinroPlayerDocument>
      | null
      | undefined,
    jinroPlayer: undefined as JinroPlayerDocument | null | undefined,
    jinroGamePlayinfo: undefined as
      | JinroGamePlayinfoDocument
      | null
      | undefined,
    jinroPlayerGame: undefined as jinroPlayerGameDocument | null | undefined,
    jinroGame: undefined as JinroGameDocument | null | undefined,
    gmJinroGame: undefined as GmJinroGameDocument | null | undefined,
    jinroRoom: undefined as JinroRoomDocument | null | undefined,
    jinroHomeActiveTab: 0,
    soundSetting: SoundSettingvalues.OFF as SoundSettingvalues,
    soundSettingVolume: DEFAULT_SOUND_VOLUME as number,
  },
  mutations: {
    setFirebaseUser(state, firebaseUser: User | null) {
      state.firebaseUser = firebaseUser;
    },
    setUser(state, user: UserDocument | null) {
      state.user = user;
    },

    setJinroRoomPlayers(state, players: Array<JinroPlayerDocument> | null) {
      state.jinroRoomPlayers = players;
    },
    setJinroPlayer(state, player: JinroPlayerDocument | null) {
      state.jinroPlayer = player;
    },
    setJinroGamePlayinfo(state, playInfo: JinroGamePlayinfoDocument | null) {
      state.jinroGamePlayinfo = playInfo;
    },
    setJinroPlayerGame(
      state,
      jinroPlayerGameDocument: jinroPlayerGameDocument | null
    ) {
      state.jinroPlayerGame = jinroPlayerGameDocument;
    },
    setJinroGame(state, jinroGameInfoDocument: JinroGameDocument | null) {
      state.jinroGame = jinroGameInfoDocument;
    },
    setGmJinroGame(state, gmJinroGame: GmJinroGameDocument | null) {
      state.gmJinroGame = gmJinroGame;
    },
    setJinroRoom(state, jinroRoom: JinroRoomDocument | null) {
      state.jinroRoom = jinroRoom;
    },
    setJinroHomeActiveTab(state, tabIndex: number) {
      state.jinroHomeActiveTab = tabIndex;
    },
    setSoundSetting(state, setting: SoundSettingvalues) {
      state.soundSetting = setting;
    },
    setSoundSettingVolume(state, volume: number) {
      state.soundSettingVolume = volume;
    },
  },
  actions: {},
  modules: {},
});
